export const USER_FETCH = 'user/show/USER_FETCH';
export const USER_SHOW = 'user/show/USER_SHOW';
export const IS_LOADED = 'user/show/IS_LOADED';
export const UPDATE_PASSWORD = 'user/password/UPDATE_PASSWORD';
export const UPDATE_PASSWORD_SUCESS = 'user/password/UPDATE_PASSWORD_SUCESS';